import _asyncToGenerator from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Wallet from './wallet-class';
var HardwareWallet = /*#__PURE__*/function (_Wallet) {
  _inherits(HardwareWallet, _Wallet);
  var _super = _createSuper(HardwareWallet);
  function HardwareWallet() {
    var _this;
    _classCallCheck(this, HardwareWallet);
    _this = _super.call(this);
    var instance = _assertThisInitialized(_this);
    instance.hardwareWallet = true;
    instance.hardwareStatus = 0;
    return _this;
  }
  _createClass(HardwareWallet, [{
    key: "attachDevice",
    value: function () {
      var _attachDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function attachDevice() {
        return _attachDevice.apply(this, arguments);
      }
      return attachDevice;
    }()
  }, {
    key: "switchToAddress",
    value: function () {
      var _switchToAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function switchToAddress() {
        return _switchToAddress.apply(this, arguments);
      }
      return switchToAddress;
    }()
  }, {
    key: "setSelectDeviceFn",
    value: function setSelectDeviceFn() {}
  }, {
    key: "cancelReadHardwareAccounts",
    value: function cancelReadHardwareAccounts() {}
  }, {
    key: "readHardwareAccounts",
    value: function readHardwareAccounts() {}
  }, {
    key: "getAddressIndex",
    value: function getAddressIndex() {
      var instance = this;
      if (!instance.address || !instance.accounts) {
        return -1;
      }
      return instance.accounts.indexOf(instance.address);
    }
  }]);
  return HardwareWallet;
}(Wallet);
export default HardwareWallet;